import BForm from "@/components/singles/BForm/component.vue";
import BModal from "@/components/singles/BModal/component.vue";

export default {
  name: "",
  components: {
    BForm,
    BModal
  },
  props: [],
  data() {
    return {
      showModal: false,
      isLoading: false,
      billingForm: {
        valid: false,
        selects: [
          {
            name: "countries",
            nameProp: "name",
            title: "Country",
            selected: null,
            order: "name",
            validation: "required",
            items: []
          }
        ],
        inputs: [
          {
            name: "firstName",
            placeholder: "First name",
            type: "text",
            label: null,
            validation: "required|min:3",
            value: "",
            focus: true
          },
          {
            name: "lastName",
            placeholder: "Last name",
            type: "text",
            label: null,
            validation: "required|min:3",
            value: ""
          },
          {
            name: "company",
            placeholder: "Company name",
            type: "text",
            label: null,
            validation: "required|min:3",
            value: ""
          },
          {
            name: "vat",
            placeholder: "VAT number",
            type: "text",
            label: null,
            validation: "min:3",
            value: ""
          },
          {
            name: "streetAddress",
            placeholder: "Street address",
            type: "text",
            label: null,
            validation: "required|min:3",
            value: ""
          },
          {
            name: "postalCode",
            placeholder: "Postal code",
            type: "text",
            label: null,
            validation: "required|min:3",
            value: ""
          }
        ]
      },

      form: {
        valid: false,
        inputs: [
          {
            icon: "fa-user",
            name: "username",
            placeholder: "Email",
            type: "text",
            label: null,
            validation: "required|email",
            value: "",
            focus: true
          },
          {
            icon: "fa-key",
            label: null,
            name: "password",
            placeholder: "Password",
            type: "password",
            validation: "required|min:8|confirmed:confirmation",
            value: ""
          }
        ]
      }
    };
  },
  computed: {},

  created() {
    this.LoadCountries();
  },
  mounted() {},

  methods: {
    async LoadCountries() {
      if (this.billingForm.selects[0].items.length === 0) {
        this.billingForm.selects[0].items = (
          await this.$helpers.PostApi("get/countryList", {}, true)
        ).map(x => {
          return {
            name: x,
            value: x
          };
        });
      }
    },
    async Signup() {
      if (this.form.valid && this.billingForm.valid) {
        this.isLoading = true;

        this.$helpers
          .PostApi(
            "signup",
            {
              username: this.form.inputs[0].value.toLowerCase(),
              name: "",
              password: this.form.inputs[1].value,

              billing: {
                firstName: this.billingForm.inputs[0].value,
                lastName: this.billingForm.inputs[1].value,
                company: this.billingForm.inputs[2].value,
                vat: this.billingForm.inputs[3].value,
                streetAddress: this.billingForm.inputs[4].value,
                postalCode: this.billingForm.inputs[5].value,
                country: this.billingForm.selects[0].selected.value
              }
            },
            true,
            false
          )
          .then(res => {
            this.isLoading = false;
            this.$router.push({
              path: "signin"
            });
            this.$helpers.ShowStatus(
              "Sign up was successful. Please login to you new account.",
              10000,
              "success"
            );
          })
          .catch(err => {
            this.isLoading = false;
            if (err.response.status === 409) {
              this.$helpers.ShowStatus(
                "The user already exists.",
                10000,
                "warning"
              );
            } else if (err.response.status === 500) {
              this.$helpers.ShowStatus(
                "Could not sign up: server error.",
                10000,
                "warning"
              );
            } else if (err.response.status === 400) {
              this.$helpers.ShowStatus(err.response.data, 10000, "warning");
            }
          });
      }
    }
  }
};
